class KitDigital {
  readonly keyPath: string
  loading: boolean
  static readonly allowedExtensions: string[] = [".xlsx", ".xls", ".csv"]

  constructor(keyPath: string, loading: boolean = false) {
    this.keyPath = keyPath
    this.loading = loading
  }

  static validatePath(keyPath: string): string {
    if (!keyPath || typeof keyPath !== "string" || !keyPath.trim()) {
      throw new Error("Ruta inválida")
    }
    const trimmed = keyPath.trim()
    const ok = KitDigital.allowedExtensions.some(ext =>
      trimmed.toLowerCase().endsWith(ext)
    )
    if (!ok) throw new Error("Extensión no permitida")
    return trimmed
  }

  isLoading(): boolean {
    return this.loading
  }

  setLoading(state: boolean): void {
    this.loading = state
  }
}

export { KitDigital }
